module.exports = __webpack_public_path__ + "img/04.e763e200.jpg";